import { Routes } from '@angular/router';

import { HomeRoutes } from './home/index';
import { UnderMaintenanceComponent } from './under-maintenance/under-maintenance.component';

export const routes: Routes = [
  ...HomeRoutes,
    {
    path: 'under-maintenance',
    component: UnderMaintenanceComponent
    }
];
